import { type SolarLatLng } from '@payaca/components/solarRoofView/SolarRoofView';

/**
 * Client-side mirror of the server's onProperty marking: is a panel's centre
 * inside the site's title parcel? Without this, an edit could silently
 * re-fill the neighbour's half on a merged building.
 */
export const panelCentreOnProperty = (
  corners: SolarLatLng[],
  parcelRing: SolarLatLng[] | null | undefined
): boolean => {
  // No parcel data: default to on-property, matching the server's default.
  if (!parcelRing || parcelRing.length < 3 || corners.length === 0) {
    return true;
  }
  const lat = corners.reduce((sum, c) => sum + c.lat, 0) / corners.length;
  const lng = corners.reduce((sum, c) => sum + c.lng, 0) / corners.length;
  let inside = false;
  for (let i = 0, j = parcelRing.length - 1; i < parcelRing.length; j = i++) {
    const a = parcelRing[i];
    const b = parcelRing[j];
    if (
      a.lat > lat !== b.lat > lat &&
      lng < ((b.lng - a.lng) * (lat - a.lat)) / (b.lat - a.lat) + a.lng
    ) {
      inside = !inside;
    }
  }
  return inside;
};
